import { getAddonsFromSelections } from "../../../../modules/addons/utils";
import { context, updateContextState } from "../../wr-context";
import { makeAction, WorkflowUnit } from "./../workflow";
import { isPathMatch } from "./utils";
var PRODUCT_SELECTION_KEY = "addonConfiguration";
export var setAddonSelection = makeAction("setAddonSelection", function(next) {
    var _constants = context.constants, addOnCatalogId = _constants.client.addOnCatalogId;
    updateContextState(function(state) {
        var catalogs = state.catalogs, cart = state.cart, selectedAddons = state.selectedAddons;
        var addOnCatalog = catalogs.find(function(catalog) {
            return catalog.id === addOnCatalogId;
        });
        state.selectedAddons = getAddonsFromSelections(cart, addOnCatalog.contents.items, selectedAddons);
    });
    next();
});
export var redirectToAddonConfiguration = makeAction("redirectToAddonConfiguration", function(next) {
    if (context.state.selectedAddons && context.state.selectedAddons.length) {
        context.history.push(context.getRoutePath("addOns"));
    } else {
        next();
    }
}, function() {
    return isPathMatch("addOns");
});
export var defaultActions = [
    setAddonSelection,
    redirectToAddonConfiguration
];
export var createAddonConfigurationUnit = function(options) {
    var ref;
    var productSelectionActions = (ref = options === null || options === void 0 ? void 0 : options.actions) !== null && ref !== void 0 ? ref : defaultActions;
    return new WorkflowUnit(PRODUCT_SELECTION_KEY, productSelectionActions);
};
var AddonConfigurationUnit = createAddonConfigurationUnit();
export default AddonConfigurationUnit;
